import { Input } from '@builder.io/sdk';

import { alignment } from './alignment';

export const blockStyling = {
  name: 'styling',
  type: 'object',
  helperText: 'Pick from styling options to customize the block.',
  defaultValue: {
    style: 'none',
    marginX: 'none',
    marginY: 'none',
    alignment: 'left',
    justify: 'start'
  },
  subFields: [
    {
      name: 'style',
      type: 'string',
      defaultValue: 'none',
      enum: ['none'],
      helperText:
        'Choose a style for the block. These styles are predefined and should be overwritten by the below fields.'
    },
    {
      name: 'backgroundColor',
      type: 'color'
    },
    {
      name: 'textColor',
      type: 'color'
    },
    {
      name: 'marginX',
      type: 'string',
      enum: ['none', 'small', 'medium', 'large'],
      defaultValue: 'none'
    },
    {
      name: 'marginY',
      type: 'string',
      enum: ['none', 'small', 'medium', 'large'],
      defaultValue: 'none'
    },
    {
      name: 'paddingX',
      type: 'string',
      enum: ['none', 'small', 'medium', 'large', 'xlarge'],
      defaultValue: 'none'
    },
    {
      name: 'paddingY',
      type: 'string',
      enum: ['none', 'small', 'medium', 'large', 'xlarge'],
      defaultValue: 'none'
    },
    alignment,
    {
      name: 'justify',
      type: 'string',
      enum: ['start', 'center', 'end', 'between', 'around', 'evenly'],
      defaultValue: 'start',
      description: 'The justification of the content block.'
    }
  ]
} satisfies Input;
